import type { StatusColor } from '../base/StatusToneEnum'
import { StatusToneEnum } from '../base/StatusToneEnum'

export enum DbRestoreStageStatusEnum {
  Pending = 'Pending',
  Running = 'Running',
  Done = 'Done',
  Failed = 'Failed',
}

export type DbRestoreStageStatusDetailType = {
  description: string
  value: DbRestoreStageStatusEnum
} & StatusColor

export const DbRestoreStageStatus: Record<keyof typeof DbRestoreStageStatusEnum, DbRestoreStageStatusDetailType> = {
  Pending: {
    value: DbRestoreStageStatusEnum.Pending,
    description: 'The stage has not started yet.',
    tone: StatusToneEnum.Draft,
  },
  Running: {
    value: DbRestoreStageStatusEnum.Running,
    description: 'The stage is running now.',
    tone: StatusToneEnum.InProgress,
  },
  Done: {
    value: DbRestoreStageStatusEnum.Done,
    description: 'The stage finished.',
    tone: StatusToneEnum.Active,
  },
  Failed: {
    value: DbRestoreStageStatusEnum.Failed,
    description: 'The stage stopped with an error, so the restore stopped.',
    tone: StatusToneEnum.Failure,
  },
}
